// extracted by mini-css-extract-plugin
export var cards = "resourcesHomepage-module--cards--7aefe";
export var heading = "resourcesHomepage-module--heading--7d46c";
export var page = "resourcesHomepage-module--page--ab3f5";